import { Box } from '@rbilabs/universal-components';

import { primitive, spacing } from 'styles/constants';
export const QuestIncentiveWrapper = Box.withConfig({
  backgroundColor: primitive.$bbqBrown,
  padding: spacing.$1,
  borderTopWidth: 3,
  borderTopColor: primitive.$bbqBrown,
});
